import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { setTrackDataLayer, getQueryParams } from '../../../utils/index';

const ExploreTab = ({
  resultsInfo,
  loading,
  resultsListing,
  tab,
  selectedTab,
  refineSearchCopy
}) => {

  const handleDataLayer = e => {
    e.preventDefault();
    const href = e.target.closest('a').href;
    if (href) {
      setTrackDataLayer({
        eventName: 'search_bar_navigations',
        custom: {
          search_term: getQueryParams(),
          landing_page: href
        }
      });

      window.location.href = href;
    }
  };

  return (
    <>
      <div
        className={
          tab.value === selectedTab.value
            ? 'search-results__tab-content active'
            : 'search-results__tab-content'
        }
        tabIndex={tab.value === selectedTab.value ? 0 : -1}
        role="tabpanel"
        aria-labelledby={tab.label}
      >
        {loading && !resultsListing.length > 0 ? (
          <div className="results-listing__loading"></div>
        ) : (
          <div className="search-results__container">
            <div className="search-results__info-copy">
              {resultsInfo && parse(resultsInfo)}
            </div>
            <div className="search-results__listing">
              {resultsListing.map((item, index) => (
                <div key={index} className="search-results__item">
                  {item.imageUrl && !item.link && <img src={item.imageUrl} />}
                  {item.imageUrl && item.link && (
                    <a href={item.link} onClick={e => handleDataLayer(e)}>
                      <img src={item.imageUrl} />
                    </a>
                  )}

                  <div className="search-results__item-info">
                    {item.link ? (
                      <a href={item.link} onClick={e => handleDataLayer(e)}>
                        <h3 className="search-results__item-title">
                          {parse(item.title)}
                        </h3>
                      </a>
                    ) : (
                      <h3 className="search-results__item-title">
                        {parse(item.title)}
                      </h3>
                    )}
                    <div className="search-results__item-copy rtf">
                      {item.copy ? parse(item.copy) : null}
                    </div>
                    <div className="search-results__item-categories">
                      {item.categories &&
                        item.categories.map((category, index) => {
                          return (
                            <div key={index}>
                              <a href={category.link}>{category.name}</a>
                              {index !== item.categories.length - 1 ? (
                                <span> {'>'} </span>
                              ) : (
                                ' '
                              )}
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        {refineSearchCopy && (
          <div className="search-results__refine-copy">
            {parse(refineSearchCopy)}
          </div>
        )}
      </div>
    </>
  );
};

ExploreTab.propTypes = {
  facets: PropTypes.array,
  subTitle: PropTypes.string,
  resetBtnLabel: PropTypes.string
};

export default ExploreTab;
